module.exports = __webpack_public_path__ + "static/img/icon-insurance-08.6717b6cc.png";